module.exports = __webpack_public_path__ + "statics/img/2-2.7f12a8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/icon/2-2.png
// module id = sEaO
// module chunks = 1